/*
  * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
  * SPDX-License-Identifier: MIT
  *
  * Licensed under the MIT License. See the LICENSE accompanying this file
  * for the specific language governing permissions and limitations under
  * the License.
  */

import React from 'react';

import { View, Image } from '@aws-amplify/ui-react';
import { I18n } from '@aws-amplify/core';
import logoLight from '../../assets/Logos/logo-light.png';

class ErrorPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {}
	}

	render() {
		return (
			<View textAlign="center">
				<Image
				alt="Amplify logo"
				src={logoLight}
				width="130px"
				/>
				<div className="access-denied-form">
					<p className="access-denied-header">{I18n.get("Error")}</p>
					<p className="access-denied-text">
						<center>{I18n.get("An error has occurred.")}</center>
					</p>
				</div>
			</View>
		);
	}
}

export default ErrorPage;
